import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../../services/modal.service';
import { CustomerService } from '../../services/customer.service';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'ng-casto-logout',
  templateUrl: './logout.component.html',
})
export class LogoutComponent {
  constructor(
    public modal: ModalService,
    public customer: CustomerService,
    private readonly toast: ToastService,
    private readonly translate: TranslateService,
    private readonly router: Router
  ) {}

  /** Hors de l'accueil, le client est dans un parcours qu'il ne peut plus mener sans être connecté. */
  get leavesProject(): boolean {
    return this.router.url.split(/[?#]/)[0] !== '/';
  }

  /**
   * Un projet n'existe que pour un client connecté : se déconnecter ramène donc à l'accueil.
   * Rester dans le configurateur laisserait l'iframe HomeByMe sur sa propre session, et
   * l'enregistrement aboutirait sans redemander d'authentification.
   */
  async signout(): Promise<void> {
    const leavesProject = this.leavesProject;

    this.customer.logout();
    this.modal.close();

    if (leavesProject) {
      await this.router.navigateByUrl('/');
    }

    this.toast.showSuccessToast(
      this.translate.instant('popins.logout.success.title'),
      this.translate.instant('popins.logout.success.text')
    );
  }
}
